module.exports = __webpack_public_path__ + "static/media/welcome-slider-2-en-md.cad46e5b.png";